import Action from "pages/_components/Action";
import Button from "pages/_components/Button";
import CustomTabs from "pages/_components/CustomTabs/CustomTabs";
import Dropdown from "pages/_components/Dropdown";
import { DesktopButtons, MobileButtons, ResponsiveHeader } from "pages/_components/header";
import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { bool } from "prop-types";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { actions as thirdPaymentActions } from "reducers/thirdPayment";
import { isIOS } from "react-device-detect";
import LotPaymentsTable from "./LotPaymentsTable";

const LotPaymentsPage = ({ isDesktop }) => {
    const dispatch = useDispatch();
    const { filterThirdParties, fetchingDownload } = useSelector((state) => state.thirdPayment);

    const tabsData = [
        {
            text: "payments.lotPayments.vendors.title",
            textType: "I18N",
        },
        {
            text: "payments.transfer.assets.title",
            textType: "I18N",
        },
    ];

    const handleDownload = (format) => {
        dispatch(thirdPaymentActions.downloadListThirdPayment(format, filterThirdParties));
    };

    const fetchMoreTransactions = (currentPage, filters) => {
        const data = {
            ...filters,
            pageNumber: currentPage + 1,
        };
        dispatch(thirdPaymentActions.loadMoreListThirdRequest({ ...data }));
    };

    useEffect(() => {
        dispatch(thirdPaymentActions.summaryThirdPay({}));
    }, []);

    return (
        <>
            <Notification scopeToShow="lotPaymentsPage" />
            <ResponsiveHeader id="payments.lotPayments.title">
                <DesktopButtons>
                    <Dropdown
                        image="images/figma/icon/download.svg"
                        label="global.download"
                        buttonClass="btn btn-outline"
                        fetching={fetchingDownload}
                        pullRight>
                        <Button
                            onClick={() => handleDownload("pdf")}
                            label="global.download.pdf"
                            className="dropdown__item-btn"
                            bsStyle="link"
                        />
                        <Button
                            onClick={() => handleDownload("xls")}
                            label="global.download.xls"
                            className="dropdown__item-btn"
                            bsStyle="link"
                        />
                        <Button
                            onClick={() => handleDownload("csv")}
                            label="global.download.csv"
                            className="dropdown__item-btn"
                            bsStyle="link"
                        />
                    </Dropdown>
                    <Link className="btn btn-primary btn-block" to="/lotPayments/newPayment">
                        <Image src="images/figma/icon/nuevo.svg" className="icon-medium svg-icon" />
                        <I18n id="payments.lotPayments.new" />
                    </Link>
                </DesktopButtons>
                <MobileButtons
                    image={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"}>
                    <Action labelKey="payments.lotPayments.new" to="/lotPayments/newPayment" />
                    <Action labelKey="global.download.pdf" handleClick={() => handleDownload("pdf")} />
                    <Action labelKey="global.download.xls" handleClick={() => handleDownload("xls")} />
                    <Action labelKey="global.download.csv" handleClick={() => handleDownload("csv")} />
                </MobileButtons>
            </ResponsiveHeader>
            <MainContainer>
                <CustomTabs tabsData={tabsData}>
                    <LotPaymentsTable
                        isDesktop={isDesktop}
                        positionTab={0}
                        fetchMoreTransactions={fetchMoreTransactions}
                    />
                    <LotPaymentsTable
                        isDesktop={isDesktop}
                        positionTab={1}
                        fetchMoreTransactions={fetchMoreTransactions}
                    />
                </CustomTabs>
            </MainContainer>
        </>
    );
};

export default LotPaymentsPage;

LotPaymentsPage.propTypes = {
    isDesktop: bool.isRequired,
};
